import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconHomePlus: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconHomePlus"><Path fillRule="evenodd" clipRule="evenodd" d="M21 8.44531V21H3V8.44531L12 2.82031L21 8.44531ZM11 12H9V14H11V16H13V14H15V12H13V10H11V12Z" fill="currentColor"/></CentralIconBase>;
});

export default IconHomePlus;
